<div class="input-container focus-rect" [class.red]="invalid">
  <label [for]="id" [class.red]="invalid" [innerHtml]="textLabelName | translate"></label>
  <img [src]="iconPath" [class.novalue]="isEmpty">
  <input type="text" [id]="id" [placeholder]="placeholder" [value]="val" (input)="onValueChange($event)"
    (change)="onValueChange($event)" (blur)="onTouch()" autocomplete="off" [attr.maxlength]="maxlength" />
</div>
<div *ngIf="invalid" class="errmsg">{{errormessage | translate }}</div>

